import loadable from '@loadable/component';

const OrderListComponent = loadable(
  () => import('../../components/Order/OrderList')
);

const OrderList = () => {
  return <OrderListComponent />;
};

export default OrderList;
